import DateRefresher from "date-refresher";

import CF from "./common-functions";
import cars from "./cars-info";

const MAX_ADVANTAGE = Math.max.apply(
  null,
  cars.map((car) => car.advantage)
);
let date = CF.getDateString();

const PHONE = "+7 (495) 021-71-07";

const PHONE_RAW = PHONE.replace(/\D+/g, "");

export default {
  address: "г. Химки, Ленинградское шоссе, вл.18",
  phone: PHONE,
  phone_raw: PHONE_RAW,
  max_advantage: MAX_ADVANTAGE,
  worktimes: "Ежедневно с 9:00-21:00",
  coords: {
    x_center_big: 37.420823,
    x_center_small: 37.420823,
    y_center: 55.899497,
    x_salon: 37.420823,
    y_salon: 55.899497,
  },
  end_day: date.split(" ")[0],
  end_month: date.split(" ")[1],
  end_date: DateRefresher.updateByInterval("19.07.2023", 3, "00:00"),
  salon_name: "GEELY Автомир Химки",
  teh_name: "GEELY Автомир Химки",
  dealer_name: "Автомир Химки",
  site: "geely-avtomir.ru",
  yur_name: "Автомир-Трейд",
  dealer_phone: '+7 (495) 182-00-82',
  need_agreement: true,
  cKeeper: "actioncall",
};